import { createContext, useState, useContext, PropsWithChildren } from 'react';

import IJobScreenContext from '../types/IJobScreenContext';

export const JobScreenContext = createContext<IJobScreenContext | null>({ showJobScreen: false });

export default function JobScreenContextProvider(
  props: PropsWithChildren<IJobScreenContext | null>
) {
  const [showJobScreen, setShowJobScreen] = useState<IJobScreenContext | null>({
    showJobScreen: false,
  });

  return (
    <JobScreenContext.Provider value={{ ...showJobScreen, setShowJobScreen }}>
      {props.children}
    </JobScreenContext.Provider>
  );
}

export function useJobScreenContext() {
  const context = useContext(JobScreenContext);
  if (!context) {
    throw new Error('useAppState must be used within the AuthContextProvider');
  }
  return context;
}
